import { Controller } from "@hotwired/stimulus"
// Reads "12.50" from the input on submit; replaces value with cents (1250).
export default class extends Controller {
  static targets = ["display"]
  initialize() {
    this.element.closest("form")?.addEventListener("submit", () => this.normalize())
  }
  normalize() {
    const v = (this.displayTarget.value || "0").toString().trim()
    const cents = Math.round(parseFloat(v.replace(/,/g, "")) * 100) || 0
    this.displayTarget.value = String(cents)
  }
}
